import { render, staticRenderFns } from "./NftItem.vue?vue&type=template&id=e1f97de6"
import script from "./NftItem.vue?vue&type=script&lang=js"
export * from "./NftItem.vue?vue&type=script&lang=js"
import style0 from "./NftItem.vue?vue&type=style&index=0&id=e1f97de6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports